import React, { useContext } from "react";
import logoWhite from "../../assets/images/Logo-bg.png";
import logoBlack from "../../assets/images/Logo-bg.png";
import { MyContext } from "../../hooks/MyContextProvider";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Briefcase, Home, Layers, LogOut, Users } from "lucide-react";
import useBreakPoints from "../../hooks/useBreakPoints";
import MobileHeader from "./MobileHeader";
const ToggleSwitch = React.lazy(() => import("../../Component/ToggleSwitch"));

const Header = () => {
  const {
    tabContent,
    setTabContent,
    theme,
    companyData,
    updateCompanyData,
    updateToken,
  } = useContext(MyContext);
  const { isTablet } = useBreakPoints();
  const navigate = useNavigate();
  const location = useLocation();
  const handleLogout = () => {
    // Add your logout logic here
    updateCompanyData(null);

    updateToken(null);
    navigate("/");
    window.location.reload();
    localStorage.clear();
  };

  return (
    <>
      <header class="header-area-bentogrid">
        <nav class="navbar">
          <div class="container">
            <div class="menu-container tmponhover single-animation active">
              <div class="logo">
                <Link class="navbar-brand me-0" to="/dashboard">
                  <img
                    style={{ height: 60 }}
                    src={theme === "dark" ? logoWhite : logoBlack}
                    alt=""
                  />
                </Link>
              </div>
              <div class="navbar-main d-flex flex-grow-1">
                <div class="logo inner-logo d-block d-xl-none">
                  <Link class="navbar-brand me-0" to="/dashboard">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L9 0C9.39782 0 9.77936 0.158035 10.0607 0.43934C10.342 0.720644 10.5 1.10218 10.5 1.5V22.5C10.5 22.8978 10.342 23.2794 10.0607 23.5607C9.77936 23.842 9.39782 24 9 24H1.5C1.10218 24 0.720644 23.842 0.43934 23.5607C0.158035 23.2794 0 22.8978 0 22.5V1.5ZM13.5 1.5C13.5 1.10218 13.658 0.720644 13.9393 0.43934C14.2206 0.158035 14.6022 0 15 0L22.5 0C22.8978 0 23.2794 0.158035 23.5607 0.43934C23.842 0.720644 24 1.10218 24 1.5V9C24 9.39782 23.842 9.77936 23.5607 10.0607C23.2794 10.342 22.8978 10.5 22.5 10.5H15C14.6022 10.5 14.2206 10.342 13.9393 10.0607C13.658 9.77936 13.5 9.39782 13.5 9V1.5ZM13.5 15C13.5 14.6022 13.658 14.2206 13.9393 13.9393C14.2206 13.658 14.6022 13.5 15 13.5H22.5C22.8978 13.5 23.2794 13.658 23.5607 13.9393C23.842 14.2206 24 14.6022 24 15V22.5C24 22.8978 23.842 23.2794 23.5607 23.5607C23.2794 23.842 22.8978 24 22.5 24H15C14.6022 24 14.2206 23.842 13.9393 23.5607C13.658 23.2794 13.5 22.8978 13.5 22.5V15Z"
                        class="logo-icon"
                      ></path>
                    </svg>
                  </Link>
                </div>
                <ul
                  class="navbar-info m-auto border-none nav nav-tabs"
                  id="myTab"
                  role="tablist"
                >
                  <li class="nav-item nav-item">
                    <Link
                      to={"/dashboard"}
                      onClick={() => setTabContent("home")}
                      class={`nav-link ${
                        tabContent === "home" ? "active" : ""
                      }`}
                      id="home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected="false"
                    >
                      <Home
                        className={`nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      />
                      <span>Home</span>
                    </Link>
                  </li>
                  <li class="nav-item nav-item">
                    <Link
                      to={"/dashboard"}
                      onClick={() => setTabContent("profile")}
                      class={`nav-link ${
                        tabContent === "profile" ? "active" : ""
                      }`}
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="true"
                    >
                      <i
                        class={`fa-regular fa-user nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      ></i>
                      About
                    </Link>
                  </li>
                  <li class="nav-item nav-item">
                    <Link
                      to={"/dashboard"}
                      onClick={() => setTabContent("service")}
                      class={`nav-link ${
                        tabContent === "service" ? "active" : ""
                      }`}
                      id="service-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#service"
                      role="tab"
                      aria-controls="service"
                      aria-selected="false"
                    >
                      <Layers
                        className={`nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      />
                      Services
                    </Link>
                  </li>
                  <li class="nav-item nav-item">
                    <Link
                      to={"/dashboard"}
                      onClick={() => setTabContent("portfolio")}
                      class={`nav-link ${
                        tabContent === "portfolio" ? "active" : ""
                      }`}
                      id="portfolio-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#portfolio"
                      role="tab"
                      aria-controls="portfolio"
                      aria-selected="false"
                    >
                      <Briefcase
                        className={`nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      />
                      Training
                    </Link>
                  </li>
                  <li class="nav-item nav-item">
                    <Link
                      to="/member"
                      onClick={() => setTabContent("")}
                      class={`nav-link ${
                        location.pathname === "/member" ? "active" : ""
                      }`}
                      id="blog-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#blog"
                      role="tab"
                      aria-controls="blog"
                      aria-selected="false"
                    >
                      <Users
                        className={`nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      />
                      Members
                    </Link>
                  </li>
                  <li class="nav-item nav-item">
                    <Link
                      to={"/message"}
                      onClick={() => setTabContent("")}
                      class={`nav-link ${
                        location.pathname === "/message" ? "active" : ""
                      }`}
                      id="contactme-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#contactme"
                      role="tab"
                      aria-controls="contactme"
                      aria-selected="false"
                    >
                      <i
                        class={`fa-regular fa-envelope nav-icon ${
                          theme === "dark" ? "white-icon" : "black-icon"
                        }`}
                      ></i>
                      Message
                    </Link>
                  </li>
                </ul>
                <ToggleSwitch />
                {/* 
              <div className="profile-section" style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '20px',
                padding: '8px 16px',
                background: theme === "dark" ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                borderRadius: '30px',
                transition: 'all 0.3s ease',
                gap: '12px'
              }}> */}
                {/* <div className="profile-image" style={{
                  width: '42px',
                  height: '42px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: theme === "dark" ? '2px solid rgba(255,255,255,0.3)' : '2px solid rgba(0,0,0,0.3)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }}>
                  <img 
                    src={companyData?.profilePhoto || defaultProfileImage} 
                    alt="Profile"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </div>
                <h6 className="mb-0" style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  color: theme === "dark" ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
                  margin: '0'
                }}>
                  {companyData?.company_name || "User"}
                </h6> */}

                <div
                  onClick={handleLogout}
                  className="logout-btn-container"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "10px",
                    borderRadius: "50%",
                    background: "#4c4685",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    boxShadow: "0 4px 10px rgba(76, 70, 133, 0.3)",
                    border: "2px solid transparent"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow = "0 6px 15px rgba(76, 70, 133, 0.45)";
                    e.currentTarget.style.background = "#5d56a3";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(76, 70, 133, 0.3)";
                    e.currentTarget.style.background = "#4c4685";
                  }}
                >
                  <LogOut
                    size={20}
                    style={{
                      color: "#fff",
                      transition: "all 0.3s ease",
                    }}
                  />
                </div>

                {/* </div> */}
              </div>
              <div class="tmp-light light-center-center"></div>
            </div>
          </div>
        </nav>
      </header>
      {isTablet && <MobileHeader />}
    </>
  );
};

export default Header;
